import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api/tenant-portal";

const TOK_KEY = "tenant_portal_token";
export const getTenantToken = () => localStorage.getItem(TOK_KEY) || "";
export const setTenantToken = (t) => t ? localStorage.setItem(TOK_KEY, t) : localStorage.removeItem(TOK_KEY);

const call = async (method, path, data) => {
  const headers = { "Content-Type": "application/json" };
  const t = getTenantToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const r = await axios({ method, url: `${BASE}${path}`, data, headers, withCredentials: false, responseType: path.endsWith("/pdf") ? "blob" : "json" });
  return r.data;
};

export const tapi = {
  login: (identifier, password) => call("post", "/login", { identifier, password }),
  changePasswordWithReset: (reset_token, new_password) =>
    call("post", "/change-password", { reset_token, new_password }),
  changePassword: (old_password, new_password) =>
    call("post", "/change-password", { old_password, new_password }),
  me: () => call("get", "/me"),
  invoices: () => call("get", "/invoices"),
  invoicePdfUrl: (iid) => `${BASE}/invoices/${iid}/pdf`,
  createOrder: (invoice_ids) => call("post", "/pay/order", { invoice_ids }),
  verifyPayment: (payload) => call("post", "/pay/verify", payload),
  manualPay: (payload) => call("post", "/pay/manual", payload),
  payments: () => call("get", "/payments"),
  notifications: () => call("get", "/notifications"),
  markRead: (id) => call("post", "/notifications/read", { id }),
  markAllRead: () => call("post", "/notifications/read-all", {}),
};

export const inr = (v) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(v || 0));
export const fmtDate = (s) => s ? new Date(s).toLocaleDateString("en-IN") : "-";

export const loadRazorpay = () => new Promise((resolve) => {
  if (window.Razorpay) return resolve(true);
  const s = document.createElement("script"); s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve(true); s.onerror = () => resolve(false);
  document.body.appendChild(s);
});
